export default "__VITE_ASSET__gMl4xThf__"